/* Touch contact on a product card shows its second photo.
 *
 * The theme's card swaps to the second image on :hover, but that rule sits
 * inside `(hover: hover) and (pointer: fine)`, so on a phone it never runs —
 * the second image is in the DOM on every card, just permanently hidden.
 * This gives touch the same behaviour: whatever card is under the finger is
 * treated as hovered, and it follows the finger.
 *
 * Scrolling counts. A thumb resting on the grid while the page moves is the
 * normal way people read a collection, so the card under it previews as it
 * passes — the finger does not have to stay still. The only thing that is
 * deliberately not instant is the very first touch: a tap opens the product,
 * and swapping the image for the instant between touchstart and navigation
 * would read as a glitch, so a stationary finger waits out a short hold. Once
 * the finger moves, that caution is pointless and the swap is immediate.
 *
 * Only the photo changes. The quick-view button and the hover info panel stay
 * hidden: they would appear directly under the finger and catch the tap that
 * was meant for the product.
 */
(function () {
  "use strict";

  var PRESSED = "is-pressed";
  var HOLD_MS = 120; // tells a deliberate press from a tap-through

  var card = null;
  var timer = null;
  var frame = null;

  function cardAt(x, y) {
    var el = document.elementFromPoint(x, y);
    if (!el || !el.closest) return null;
    return el.closest(".product-card");
  }

  function setCard(next) {
    if (next && !next.querySelector(".media--second")) next = null;
    if (next === card) return;
    if (card) card.classList.remove(PRESSED);
    card = next;
    if (card) card.classList.add(PRESSED);
  }

  function clear() {
    clearTimeout(timer);
    timer = null;
    if (frame) {
      cancelAnimationFrame(frame);
      frame = null;
    }
    setCard(null);
  }

  document.addEventListener(
    "touchstart",
    function (event) {
      clear();
      var target = event.target;
      if (!target || !target.closest) return;
      // Controls inside the card do their own thing — the quick-view eye, the
      // quick-add button — and should not be hidden behind a photo swap.
      if (target.closest("button, [role='button'], select, input, label")) {
        return;
      }
      var touch = event.changedTouches[0];
      if (!touch) return;
      var x = touch.clientX;
      var y = touch.clientY;
      timer = setTimeout(function () {
        setCard(cardAt(x, y));
      }, HOLD_MS);
    },
    { passive: true }
  );

  document.addEventListener(
    "touchmove",
    function (event) {
      var touch = event.changedTouches[0];
      if (!touch) return;
      // Moving means this is a scroll or a scrub, not a tap, so the hold no
      // longer needs waiting out.
      clearTimeout(timer);
      timer = null;
      if (frame) return; // one lookup per frame — touchmove fires far faster
      var x = touch.clientX;
      var y = touch.clientY;
      frame = requestAnimationFrame(function () {
        frame = null;
        setCard(cardAt(x, y));
      });
    },
    { passive: true }
  );

  document.addEventListener("touchend", clear, { passive: true });
  document.addEventListener("touchcancel", clear, { passive: true });
})();
